import React, { useState, memo } from 'react';
import { useInView } from 'react-intersection-observer';
import {injectIntl} from "gatsby-plugin-intl"
import './testimonials.scss';
import Image from '../../image';


const testimonials = [
  {
    comment: 'Testimonials1',
    userAvatar: 'James_F.png',
    userName: 'James F.',
    userTitle: '',
    userCompany: '@United Kingdom',
  },
  {
    comment: 'Testimonials2',
    userAvatar: 'Lana.png',
    userName: 'Lana M.',
    userTitle: '',
    userCompany: '@Austria',
  },
];

const Testimonials = ({intl: { formatMessage }}) => {
  const [currentInView, setCurrentInView] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0,
  });
  if (inView && !currentInView) {
    setCurrentInView(true);
  }
  return (
    <div className="testimonials-section" ref={ref}>
      <div className="page-content">
        <ul className="testimonials">
          <div className="title"> {formatMessage({id: "Testimonials"})}</div>
          {testimonials.map((element) => (
            <li key={element.userName}>
              <div className="comment">{formatMessage({id: element.comment})}</div>
              <div className="user">
                <div className="img-wrap">
                  <Image src={element.userAvatar} alt={element.userName} className="avatar" />
                </div>
                <div className="name">{element.userName}</div>
                <div className="descr">
                  {element.userTitle}
                  {' '}
                  {element.userCompany}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default memo(injectIntl(Testimonials));
